import { PaymentType } from '@shared/enums/payment-type';
import { HardwareProduct } from '@shared/models/hardware-product.model';

export class AccessoryProductAddAction {
  public static readonly type = '[Accessory product] Add hardware product';
  constructor(public hardwareProduct: HardwareProduct) {}
}

export class AccessoryProductRemoveConfirmAction {
  public static readonly type = '[Accessory product] Confirm remove hardware product';
  constructor(public productId: string) {}
}

export class SetPaymentTypeOnAccessoryAction {
  public static readonly type = '[Accessory product] Set payment Type';
  constructor(
    public productId: string,
    public paymentType: PaymentType
  ) {}
}

export class AccessoryProductResetAction {
  public static readonly type = '[Accessory product] Reset hardware product state';
}

export class SetNewVoiceProductOnAccessoryProductAction {
  public static readonly type = '[Accessory product] Set new voice product on accessory product';
  constructor(
    public productId: string,
    public offeringId: string
  ) {}
}

export class SetVoiceProductOnAccessoryProductAction {
  public static readonly type = '[Accessory product] Set voice product on accessory product';
  constructor(
    public productId: string,
    public voiceProductId: string
  ) {}
}

export class RemoveAccessoryProductAction {
  public static readonly type = '[Accessory product] Remove accessory product';
  constructor(public productId: string) {}
}
